/** OAuth post-auth redirect URLs (e.g. postauth?error=EMAIL_NOT_VERIFIED) surface errors in query params. */
export const OAUTH_POSTAUTH_ERROR_I18N_KEYS: Record<string, string> = {
  EMAIL_NOT_VERIFIED: "authentication.oauth_error_email_not_verified",
  PASSWORD_RESET_REQUIRED:
    "authentication.oauth_error_password_reset_required",
  PASSWORD_EXPIRED: "authentication.oauth_error_password_expired",
  PASSWORD_POLICY_ERROR: "authentication.oauth_error_password_policy_error",
};

export function getOAuthErrorMessageFromResponseUrl(
  responseUrl: string,
  translate: (key: string) => string
): string | null {
  try {
    const errorCode = new URL(responseUrl).searchParams.get("error");
    if (!errorCode) return null;
    const i18nKey = OAUTH_POSTAUTH_ERROR_I18N_KEYS[errorCode];
    return i18nKey
      ? translate(i18nKey)
      : translate("authentication.oauth_error_generic");
  } catch {
    return null;
  }
}
